import { render, staticRenderFns } from "./ViewShipmentComponent.vue?vue&type=template&id=1ac903c0"
import script from "./ViewShipmentComponent.vue?vue&type=script&lang=js"
export * from "./ViewShipmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports